import { SET_USER_DATA } from "../types";
import configVars from "../../config";
export const getUserData = (token) => async (dispatch) => {
  try {
    let userRequestData = new FormData();
    userRequestData.append("token", token);

    const response = await fetch(
      `${configVars.apiUrl}sustainchange/v1/getuserbyid/`,
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
        },
        body: userRequestData,
      }
    );

    const allUserData = await response.json();
    dispatch({ type: SET_USER_DATA, payload: allUserData.data });
    return { data: allUserData.data };
  } catch (error) {
    console.log({ error });
    return { error: error };
  }
};
